const SET = 'patron/program/SET';

export default {
  SET,
};
